import { useContext, useMemo } from "react";

import { StaffPermission, UserType } from "../generated-graphql/graphql";
import { currentUserContext, checkIsOriginalUserStaff } from "../providers/user";

/**
 * The currently authenticated user
 */
export function useCurrentUser() {
  const { user, loading, refetchUser } = useContext(currentUserContext);

  return useMemo(() => {
    const isStaff = !!user && user.type !== UserType.Customer;
    const isCustomer = !!user && user.type === UserType.Customer;
    const isOriginalUserStaff = checkIsOriginalUserStaff(user);
    // Staff permissions only apply to staff (e.g. not while emulating a customer).
    const staffPermissions = isStaff ? (user?.staffPermissions ?? []) : [];
    return {
      user,
      loading,
      isStaff,
      isOriginalUserStaff,
      isCustomer,
      isEmulating: !!user?.isEmulating,
      isPartner: !!user?.isPartner,
      isCsm: !!user?.isCsm,
      refetchUser,
      staffPermissions,
      hasStaffPermission: (permission: StaffPermission) => staffPermissions.includes(permission),
    };
  }, [loading, user, refetchUser]);
}
